import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { askForPermissionToReceiveNotifications } from '../../firebaseConfig';
import { UPLOADNODEURL, BASEAPIURL, BASEURL, LogOutAll, UPLOADNODEURLCDN, getCourseURL } from '../../config';
import StickyMenu from '../../lib/StickyMenu';
import Add2CartPopup from '../Checktout/Add2CartPopup';
import { BuyThisCourseStdAfterLoginAuto, FetchCoursetoBuy } from '../Students/functions';
import { UpdateCommonData } from '../../reduxFunction/commonSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { changeLanguage } from '../../reduxFunction/appSlice';
import DataService from '../../lib/AxiosInstance';
import './HeaderInstitute.css';
import './rypopup.css';

let ForDateTopMsg = localStorage.getItem('TopMsg');

// function Header({ action, type, pageName, HideBottomMenu }) {
function Header({ action, type, HideBottomMenu }) {
    const { t, i18n } = useTranslation();
    function changeLanguage2(lng) {
        localStorage.setItem('defLang', lng);
        i18n.changeLanguage(lng);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const couponCode = urlParams.get('couponCode');
    const CommonData = useSelector((state) => state.commonData);
    const dispatch = useDispatch();
    const [defaultProfilePicture] = useState('placeholders/userProfileImg.png');
    const [userData, Setuserdata] = useState({ name: '', photo: '' });
    const [OnCart, SetOnCart] = useState(FetchCoursetoBuy().length);
    const [UserType, setUserType] = useState(localStorage.getItem('usertype'));
    const [UserName, setUserName] = useState(localStorage.getItem('username'));
    // ReactGA.initialize(GoogleAnylyticsID);
    // For Top Messages
    const [DocstaTopMsgDisplay, setDocstaTopMsgDisplay] = useState('none');
    const [DocstaTopMsg, setDocstaTopMsg] = useState({});
    // For Top Messages

    // for Search Course By Keywords
    const [ShowMobileSearch, setShowMobileSearch] = useState('none');
    const [KeySearchCourses, setKeySearchCourses] = useState([]);
    const [KeySearchInstructor, setKeySearchInstructor] = useState([]);
    // for Search Course By Keywords

    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

    const fetchDocstaTopMsg = async () => {
        try {
            const res = await fetch(`${BASEAPIURL}/admin/topmessage/getHeaderMsg`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SortStatus: 1,
                    recordsPerPage: 1,
                    sortby: 'latest',
                    country: localStorage.getItem('country_name'),
                }),
            });
            const resJson = await res.json();
            if (res.status === 200) {
                if (Object.keys(resJson.data).length > 0) {
                    setDocstaTopMsg(resJson.data[0]);
                    setDocstaTopMsgDisplay('block');
                } else {
                    setDocstaTopMsgDisplay('none');
                }
            } else {
                console.log(resJson.message);
                setDocstaTopMsgDisplay('none');
            }
        } catch (err) {
            console.log(err);
            setDocstaTopMsgDisplay('none');
        }
    };

    function showKeywordSearch() {
        if ( KeySearchCourses.length === 0 && KeySearchInstructor.length === 0 ) {
            dispatch(UpdateCommonData({ showKeywordSearch: 'block' }));
        } else {
            dispatch(UpdateCommonData({ showKeywordSearch: 'block' }));
        }
    }

    const FilterCoursesbyKeyword = async (e, keyword) => {
        if (keyword === '') {
            setKeySearchCourses([]);
            showKeywordSearch();
            return 0;
        } else {
            try {
                const res = await fetch(`${BASEAPIURL}/course/getAll`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        SortStatus: 1,
                        recordsPerPage: 30,
                        keyword: keyword.trim(),
                        sortby: 'a2z',
                    }),
                });
                const resJson = await res.json();
                if (res.status === 200) {
                    if (resJson.data.length > 0) {
                        setKeySearchCourses(resJson.data);
                        showKeywordSearch();
                    } else {
                        setKeySearchCourses([]);
                        showKeywordSearch();
                    }
                } else {
                    console.log(resJson.message);
                }
            } catch (err) {
                console.log(err);
            }
        }
        return 1;
    };

    const FilterInstructorsbyKeyword = async (e, keyword) => {
        e.preventDefault();
        if (keyword === '') {
            showKeywordSearch();
            setKeySearchInstructor([]);
            return 0;
        } else {
            try {
                const res = await DataService.post(
                    `/admin/instructure/getAll`,
                    JSON.stringify({
                        SortStatus: 1,
                        recordsPerPage: 30,
                        keyword: keyword.trim(),
                        sortby: 'a2z',
                    })
                );
                if (res.status === 200) {
                    if (res.data.data.length > 0) {
                        setKeySearchInstructor(res.data.data);
                        showKeywordSearch();
                    } else {
                        setKeySearchInstructor([]);
                        showKeywordSearch();
                    }
                } else {
                    console.log(res.data.message);
                }
            } catch (err) {
                console.log(err);
            }
        }
        return 1;
    };

    const [eProducts, setEProducts] = useState([]);
    const [courses, setCourses] = useState([]);
    const fetchCourses = async (section) => {
        try {
            const res2 = await DataService.post(
                `/course/getAll`,
                JSON.stringify({
                    SortStatus: 1,
                    recordsPerPage: 10,
                    sortby: 'popular',
                    MainCatID: section
                })
            );
            const res2Json = await res2.data;
            if (section === 'courses') {
                setCourses(res2Json.data);
            } else {
                setEProducts(res2Json.data);
            }
        } catch (err) {
            console.log(err);
        }
    };

    async function fetchCouponCodeValidaction(code) {
        if (code && code !== '') {
            try {
                const res = await fetch(`${BASEAPIURL}/student/fetchCouponCodeValidaction`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ targetID: code, targetType: 'code' }),
                });
                const resJson = await res.json();
                if (res.status === 200) {
                    if (resJson.data && resJson.data.length > 0) {
                        localStorage.setItem('couponCodeValue', resJson.data[0].mobile);
                    }
                } else {
                    console.error(resJson.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    }

    const [Showadded2Cart, setShowadded2Cart] = useState(false);

    useEffect(() => {
        if (couponCode && couponCode !== '') {
            fetchCouponCodeValidaction(couponCode);
        }
        document.title = window.GetDocumentTitle();
        // for the Enrolled courses
        if (
            localStorage.getItem('Enroll_targetID') &&
            localStorage.getItem('Enroll_targetType') &&
            localStorage.getItem('Enroll_targetID') !== '' &&
            localStorage.getItem('Enroll_targetType') !== ''
        ) {
            setTimeout(() => {
                BuyThisCourseStdAfterLoginAuto(
                    localStorage.getItem('loggedToken'),
                    localStorage.getItem('Enroll_targetID'),
                    localStorage.getItem('Enroll_targetType'),
                    localStorage.getItem('usertype')
                );
            }, 786);
        }
        // for the Enrolled courses

        // get firebaseToken from here start
        // initializeFirebase();
        askForPermissionToReceiveNotifications();
        // get firebaseToken from here end
        const temp = localStorage.getItem('userdata');
        try {
            if (temp) {
                const resJson = JSON.parse(temp);
                Setuserdata(resJson);
            }
        } catch (error) {
            console.error('Error parsing JSON:', error);
        }
        // ReactGA.send('pageview');
        localStorage.removeItem('RYSJAIN');
        StickyMenu();
        ForDateTopMsg = localStorage.getItem('TopMsg');
        fetchDocstaTopMsg();
        // fetchCatiData('exam', 0);
        fetchCourses('courses');
        fetchCourses('eproducts');
        setUserType(localStorage.getItem('usertype'));
        setUserName(localStorage.getItem('username'));
        const interval = setInterval(() => {
            setUserType(localStorage.getItem('usertype'));
            setUserName(localStorage.getItem('username'));
        }, 5000);
        const cartInterval = setInterval(() => {
            SetOnCart(FetchCoursetoBuy().length);
        }, 2000);
        return () => {
            clearInterval(interval);
            clearInterval(cartInterval);
        };
    }, [couponCode]);

    function getKeyword() {
        const query = new URLSearchParams(useLocation().search);
        return query.get('keyword');
    }

    return (
        <>
            <span
                id="closeKeywordSearch"
                className="d-none"
                onClick={() => {
                    dispatch(UpdateCommonData({ showKeywordSearch: 'none' }));
                }}
            >
                Close Keyword Search
            </span>
            <div
                className={`${Number(HideBottomMenu) === 1 ? 'd-none' : 'd-block d-sm-none'}`}
                style={{
                    position: 'fixed',
                    bottom: '0px',
                    right: '0px',
                    left: '0px',
                    zIndex: 99,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        background: '#383838',
                        padding: '10px 0px',
                        justifyContent: 'space-around',
                        fontSize: '11px',
                    }}
                >
                    <Link to="/" className="text-center d-block text-white">
                        <b>
                            <i className="far fa-2x fa-home" style={{ fontSize: '1.5em' }}></i>
                            <br />
                            {t('home')}
                        </b>
                    </Link>
                    <Link to="/user/dashboard" className="text-center d-block text-white">
                        <b>
                            <i className="far fa-2x fa-books" style={{ fontSize: '1.5em' }}></i>
                            <br />
                            {t('myLearning')}
                        </b>
                    </Link>
                    <Link to="/user/page/profilesetting" className="text-center d-block text-white">
                        <b>
                            <i className="far fa-2x fa-user" style={{ fontSize: '1.5em' }}></i>
                            <br />
                            {t('myProfile')}
                        </b>
                    </Link>
                </div>
            </div>
            <span
                onClick={() => {
                    setShowadded2Cart(true);
                }}
                id="Showadded2CartBtn"
                className="d-none"
            >
                Show Me
            </span>
            {/* Show Popup after Add to Cart  */}
            {Showadded2Cart ? (
                <>
                    <div
                        className="ryPopUpBack"
                        onClick={() => {
                            setShowadded2Cart(false);
                        }}
                    ></div>
                    <div
                        className="ryPopUp"
                        style={{ width: '45%', minWidth: '300px', padding: '20px 5px' }}
                    >
                        <a
                            href="/"
                            className="ryPopUpAct text-white"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowadded2Cart(false);
                            }}
                        >
                            X
                        </a>
                        <div>
                            <Add2CartPopup
                                targetID={localStorage.getItem('targetID')}
                                targetType={localStorage.getItem('targetType')}
                            />
                        </div>
                    </div>
                </>
            ) : (
                ''
            )}
            {/* Show Popup after Add to Cart  */}
            <div style={{ display: ForDateTopMsg === DocstaTopMsg.updatedAt ? 'none' : '' }}>
                <div className="docsta_top_msg text-white" style={{ display: DocstaTopMsgDisplay }}>
                    <a
                        href="/"
                        className="topMessageClose"
                        onClick={(e) => {
                            setDocstaTopMsgDisplay('none');
                            localStorage.setItem('TopMsg', `${DocstaTopMsg.updatedAt}`);
                            e.preventDefault();
                        }}
                    >
                        X
                    </a>
                    <span href={DocstaTopMsg.url}>
                        <b className="text-white">{DocstaTopMsg.title}</b>
                        <p className="text-white">{DocstaTopMsg.description}</p>
                    </span>
                    <div style={{ clear: 'both' }}></div>
                </div>
            </div>
            <form
                className="SearchAnything SearchAnythingMobile d-lg-none"
                style={{ display: ShowMobileSearch }}
                autoComplete="off"
            >
                <div className="input-box" style={{ position: 'relative' }}>
                    <input
                        type="text"
                        name="keyword"
                        className="form-control"
                        placeholder={t('searchAnything')}
                        onChange={(e) => {
                            // getKeywordsHere(e, e.target.value);
                            FilterCoursesbyKeyword(e, e.target.value);
                            FilterInstructorsbyKeyword(e, e.target.value);
                        }}
                    />
                    <button
                        type="button"
                        className="btn btn-outline-danger"
                        style={{
                            position: 'fixed',
                            zIndex: 999,
                            right: '10px',
                            top: '10px',
                            border: '0px',
                            color: '#333',
                        }}
                        onClick={() => {
                            setShowMobileSearch('none');
                        }}
                    >
                        <i className="far fa-window-close"></i>
                    </button>
                    <div
                        className="SearchAnythingResult forMobile"
                        style={{
                            maxHeight: 'initial',
                            bottom: '0px',
                            position: 'fixed',
                        }}
                    >
                        {KeySearchCourses.map((singi) => (
                            <div key={singi._id} className="KeySearchDivContent">
                                <Link
                                    className="row"
                                    to={`/course/${singi.slug}`}
                                    onClick={() => {
                                        setKeySearchCourses([]);
                                        setShowMobileSearch('none');
                                    }}
                                >
                                    <div className="col-2 pr-0">
                                        <img
                                            src={`${UPLOADNODEURL}${singi.image}`}
                                            alt={singi.title}
                                        />
                                    </div>
                                    <div className="col-10">
                                        <b
                                            style={{
                                                display: 'block',
                                                fontWeight: '700',
                                            }}
                                        >
                                            {singi.title}
                                        </b>
                                        <p className='pr-3 CLB_course_title'>{singi.metaDescription}</p>
                                    </div>
                                    <div style={{ clear: 'both' }}><hr /></div>
                                </Link>
                            </div>
                        ))}
                        {KeySearchInstructor.map((singi, i) => (
                            <div key={singi._id} className="KeySearchDivContent">
                                <Link
                                    className="row"
                                    to={`/instructor/profile/${singi.slug}`}
                                    onClick={() => {
                                        setKeySearchCourses([]);
                                        setShowMobileSearch('none');
                                    }}
                                >
                                    <div className="col-2 pr-0">
                                        <img
                                            src={`${BASEAPIURL}/admin/instructure/profileimage/${singi.tid}`}
                                            alt={singi.name}
                                        />
                                    </div>
                                    <div className="col-10">
                                        <b
                                            style={{
                                                display: 'block',
                                                fontWeight: '700',
                                            }}
                                        >
                                            {singi.name}
                                        </b>
                                        <p>
                                            <small>{t('instructor')}</small>
                                        </p>
                                    </div>
                                    <div style={{ clear: 'both' }}></div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </form>
            <header className="appie-header-area appie-sticky">
                <div className="headSection">
                    <div
                        className={`container-fluid ${Number(localStorage.getItem('screenwidth')) > 767 ? 'p-0' : ''
                            }`}
                    >
                        <div className="header-nav-box">
                            <div className="row align-items-center">
                                <div className="d-lg-none d-block col-12">
                                    <div className="appie-logo-box text-center">
                                        <Link to="/">
                                            <img src='/AacumenGlowLogo.png' alt="" />
                                        </Link>
                                        <div
                                            id="showMobileSearch"
                                            // document.getElementById('showMobileSearch').click();
                                            className="toggle-btn ml-30 d-lg-none d-block"
                                            style={{ right: '40px' }}
                                            onClick={() => {
                                                setShowMobileSearch('block');
                                            }}
                                        >
                                            <i className="fa fa-search" />
                                        </div>
                                        <div
                                            onClick={(e) => action(e)}
                                            className="toggle-btn ml-30 canvas_open"
                                        >
                                            <i className="fa fa-bars" />
                                        </div>
                                        <div className="toggle-btn mr-2">
                                            <Link
                                                className="text-dark"
                                                to="/checkout/cart"
                                                style={{ position: 'relative' }}
                                            >
                                                <i className="fal fa-shopping-cart" />
                                                <span className="cartCounter">
                                                    {Number(OnCart)}
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-7 col-12 p-0 row align-items-center">
                                    <div className="appie-search-box">
                                        <Link to="/">
                                            <img
                                                src={'/AacumenGlowLogo.png'}
                                                alt=""
                                                style={{
                                                    maxWidth: '100%',
                                                    marginRight: '5px',
                                                    marginLeft: '10px',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </Link>
                                        <div className="appie-header-main-menu">
                                            <ul>
                                                <li>
                                                    <span>{t('explore')}</span>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            <a href="/courses">
                                                                {t('courses')} <i className="fal fa-angle-right" />
                                                            </a>
                                                            <ul
                                                                className="sub-menu"
                                                                style={{
                                                                    maxHeight: '90vh',
                                                                    overflow: 'auto',
                                                                }}
                                                            >
                                                                {courses && courses.map((s) => (
                                                                    <li key={s._id} style={{ maxWidth: "400px" }}>
                                                                        <Link to={getCourseURL(s.section, s.slug)}>
                                                                            <img src={`${UPLOADNODEURLCDN}${s.image}`} alt={s.title} />
                                                                            <div>
                                                                                <p>{s.title}</p>
                                                                                {/* <div
                                                                                    className="mt-2"
                                                                                    style={{ lineHeight: "1.5rem" }}
                                                                                    dangerouslySetInnerHTML={{ __html: s.metaDescription }}
                                                                                /> */}
                                                                            </div>
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <a href="/courses/eproducts">
                                                                {t('eProducts')} <i className="fal fa-angle-right" />
                                                            </a>
                                                            <ul
                                                                className="sub-menu"
                                                                style={{
                                                                    maxHeight: '90vh',
                                                                    overflow: 'auto',
                                                                }}
                                                            >
                                                                {eProducts && eProducts.map((s) => (
                                                                    <li key={s._id} style={{ maxWidth: "400px" }}>
                                                                        <Link to={getCourseURL(s.section, s.slug)}>
                                                                            <img src={`${UPLOADNODEURLCDN}${s.image}`} alt={s.title} />
                                                                            <div>
                                                                                <p>{s.title}</p>
                                                                                {/* <div
                                                                                    className="mt-2"
                                                                                    style={{ lineHeight: "1.5rem" }}
                                                                                    dangerouslySetInnerHTML={{ __html: s.metaDescription }}
                                                                                /> */}
                                                                            </div>
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <form
                                            className="SearchAnything"
                                            action={`${BASEURL}courses`}
                                            autoComplete="off"
                                        >
                                            <div
                                                className="input-box"
                                                style={{ position: 'relative' }}
                                            >
                                                <input
                                                    type="text"
                                                    name="keyword"
                                                    required
                                                    defaultValue={getKeyword()}
                                                    placeholder={t('readyToGlow')}
                                                    onChange={(e) => {
                                                        // getKeywordsHere(e, e.target.value);
                                                        FilterCoursesbyKeyword(e, e.target.value);
                                                        FilterInstructorsbyKeyword(
                                                            e,
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                                <button type="submit">
                                                    {/* <Link to="/courses-all"> */}
                                                        <i className="fal fa-search" />
                                                    {/* </Link> */}
                                                </button>
                                                <div
                                                    className="SearchAnythingResult forDesktop"
                                                    style={{
                                                        maxHeight: '70vh',
                                                        display:
                                                            KeySearchCourses.length === 0 &&
                                                                KeySearchInstructor.length === 0 
                                                                ? 'none'
                                                                : CommonData.showKeywordSearch,
                                                    }}
                                                >
                                                    {KeySearchCourses.map((singi) => (
                                                        <div
                                                            key={singi._id}
                                                            className="KeySearchDivContent"
                                                        >
                                                            <Link
                                                                to={`/course/${singi.slug}`}
                                                                onClick={() => {
                                                                    // setKeySearchDiv('none');
                                                                    setKeySearchCourses([]);
                                                                }}
                                                                style={{ display: 'block' }}
                                                            >
                                                                <img
                                                                    src={`${UPLOADNODEURL}${singi.image}`}
                                                                    alt={singi.title}
                                                                />
                                                                <div>
                                                                    <b
                                                                        style={{
                                                                            display: 'block',
                                                                            fontWeight: '700',
                                                                        }}
                                                                    >
                                                                        {singi.title}
                                                                    </b>
                                                                    <p className="CLB_course_title">{singi.metaDescription}</p>
                                                                </div>
                                                                <div
                                                                    style={{ clear: 'both' }}
                                                                ><hr /></div>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                    {KeySearchInstructor.map((singi) => (
                                                        <div
                                                            key={singi._id}
                                                            className="KeySearchDivContent"
                                                        >
                                                            <Link
                                                                to={`/instructor/profile/${singi.slug}`}
                                                                onClick={() => {
                                                                    // setKeySearchDiv('none');
                                                                    setKeySearchInstructor([]);
                                                                }}
                                                                style={{ display: 'block' }}
                                                            >
                                                                <img
                                                                    src={`${BASEAPIURL}/admin/instructure/profileimage/${singi.tid}`}
                                                                    alt={singi.name}
                                                                />
                                                                <div>
                                                                    <b
                                                                        style={{
                                                                            display: 'block',
                                                                            fontWeight: '700',
                                                                        }}
                                                                    >
                                                                        {singi.name}
                                                                    </b>
                                                                    <p>
                                                                        <small>{t('instructor')}</small>
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{ clear: 'both' }}
                                                                ></div>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-12">
                                    <div className="appie-btn-box">
                                        {type === 'instructor' ? (
                                            <>
                                                <Link to="/">
                                                    <span className="text-dark">{t('learner')}</span>
                                                </Link>
                                                <Link
                                                    className="login-btn"
                                                    to="/instructor-login"
                                                    style={{
                                                        lineHeight: 'initial',
                                                        padding: '5px 20px',
                                                        display:
                                                            UserType === 'instructor' ? '' : 'none',
                                                    }}
                                                >
                                                    {t('myAccount')}
                                                    <br />
                                                    <small>({UserName})</small>
                                                </Link>
                                                <Link
                                                    className="login-btn"
                                                    to="/instructor-login"
                                                    style={{
                                                        display:
                                                            UserType === 'instructor' ? 'none' : '',
                                                    }}
                                                >
                                                    {t('signIn')}
                                                </Link>
                                                <Link
                                                    className="signup-btn ml-1"
                                                    to="/instructor-register"
                                                    style={{
                                                        display:
                                                            UserType === 'instructor'
                                                                ? 'none'
                                                                : 'none',
                                                    }}
                                                >
                                                    {t('signUp')}
                                                </Link>
                                            </>
                                        ) : (
                                            <>
                                                <Link to="/instructor" className="d-none">
                                                    <span className="text-dark">
                                                        <b>{t('instructor')}</b>
                                                    </span>
                                                </Link>
                                                <Link
                                                    className="login-btn"
                                                    to="/user/login"
                                                    style={{
                                                        display:
                                                            UserType === 'student' ? 'none' : '',
                                                    }}
                                                >
                                                    {t('signIn')}
                                                </Link>
                                                <Link
                                                    className="signup-btn ml-1"
                                                    to="https://acumenglobalreactbackend.onrender.com/user/register"
                                                    style={{
                                                        display:
                                                            UserType === 'student'
                                                                ? 'none'
                                                                : 'none',
                                                    }}
                                                >
                                                     {t('signUp')}
                                                </Link>
                                                <Link
                                                    className="login-btn ml-1"
                                                    to="/user/dashboard"
                                                    style={{
                                                        display:
                                                            UserType === 'student' ? '' : 'none',
                                                    }}
                                                >
                                                    {t('myCourses')}
                                                </Link>
                                            </>
                                        )}
                                        <Link className="signup-btn ml-3" to="/user/register">
                                            {t('joinforFree')}
                                        </Link>
                                        <div
                                            className="px-3 position-relative"
                                            onMouseEnter={() => setShowLanguageDropdown(true)}
                                            onMouseLeave={() => setShowLanguageDropdown(false)}
                                        >
                                            <i className="fal fa-lg fa-globe" />
                                            {showLanguageDropdown && (
                                                <div
                                                    className="position-absolute shadow"
                                                    style={{ zIndex: 9999, background: 'white', right: '20px' }}
                                                >
                                                    <a
                                                        href="/"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeLanguage2('en');
                                                        }}
                                                        className="p-2 px-3 fs-6"
                                                    >
                                                        English
                                                    </a>
                                                    <a
                                                        href="/"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeLanguage2('pt');
                                                        }}
                                                        className="p-2 px-3 fs-6"
                                                    >
                                                        Portuguese
                                                    </a>
                                                    <a
                                                        href="/"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeLanguage2('fr');
                                                        }}
                                                        className="p-2 px-3 fs-6"
                                                    >
                                                        French
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                        {type !== 'instructor' && localStorage.getItem('usertype') !== "instructor" && (
                                            <Link className="pr-3" to="/checkout/cart">
                                                <i className="fal fa-lg fa-shopping-cart" />
                                                {OnCart !== 0 && <sup>{Number(OnCart)}</sup>}
                                            </Link>
                                        )}
                                        <Link to="/" onClick={(e) => action(e)}>
                                            <i className="fal fa-lg fa-bars" />
                                        </Link>
                                        <div className="appie-icon-box ml-0">
                                            {/* <Link className="appie-icon-box" to="/checkout/cart">
                                                <i className="fal fa-shopping-cart" />
                                                <span className="cartCounter">
                                                    {Number(OnCart)}
                                                </span>
                                            </Link> */}
                                            <Link
                                                className="appie-icon-box d-none ml-0"
                                                to="/user/page/MyFavourite"
                                            >
                                                <i className="fal fa-heart" />
                                            </Link>
                                            {/* <a href="#">
                                                <i className="fal fa-bell" />
                                            </a> */}
                                            {type !== 'instructora' && UserType === 'student' ? (
                                                <div className="ProfileMenuCont">
                                                    <img
                                                        src={`${UPLOADNODEURL}${userData.photo &&
                                                            userData.photo !== null &&
                                                            userData.photo !== ''
                                                            ? userData.photo
                                                            : defaultProfilePicture
                                                            }`}
                                                        alt={userData.name}
                                                        className=""
                                                    />
                                                    <div className="ProfileMenu">
                                                        <Link to="/user/page/profilesetting">
                                                            <h6>{userData.name}</h6>
                                                            {userData.email}
                                                        </Link>
                                                        <hr />
                                                        <Link to="/user/dashboard">
                                                            {t('myLearning')}
                                                        </Link>
                                                        <Link to="/user/page/MyFavourite">
                                                            {t('myWishlist')}
                                                        </Link>
                                                        <Link to="/user/page/updateprofilesetting">
                                                            {t('accountSetting')}
                                                        </Link>
                                                        <Link to="/user/page/changePassword">
                                                            {t('changePassword')}
                                                        </Link>
                                                        <Link
                                                            to="/user/dashboard"
                                                            onClick={() => {
                                                                LogOutAll();
                                                            }}
                                                        >
                                                            {t('logout')}
                                                        </Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                            )}

                                            {type !== 'instructor1' && UserType === 'instructor' ? (
                                                <div className="ProfileMenuCont">
                                                    <img
                                                        src={`${UPLOADNODEURLCDN}${userData.photo &&
                                                            userData.photo !== null &&
                                                            userData.photo !== ''
                                                            ? userData.photo
                                                            : defaultProfilePicture
                                                            }`}
                                                        alt={localStorage.getItem('username')}
                                                        className=""
                                                    />
                                                    <div className="ProfileMenu">
                                                        <Link to="/instructor/page/profilesetting">
                                                            <h6>
                                                                {localStorage.getItem('username')}
                                                            </h6>
                                                        </Link>
                                                        <hr />
                                                        <Link to="/instructor/page/mycourses">
                                                            {t('myCourses')}
                                                        </Link>
                                                        <Link to="/instructor/page/updateprofilesetting">
                                                            {t('accountSetting')}
                                                        </Link>
                                                        <Link to="/instructor/page/changePassword">
                                                            {t('changePassword')}
                                                        </Link>
                                                        <Link
                                                            to="/user/dashboard"
                                                            onClick={() => {
                                                                LogOutAll();
                                                            }}
                                                        >
                                                            {t('logout')}
                                                        </Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            <span className="mr-3"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
